import React from 'react'
import { Card } from '@shopify/polaris'

const RemittedSalesTaxSection = ({ t }) => {
	return (
		<Card title={t("home.remittedSalesTaxByStates")} sectioned>
			{t("home.noSingleSale")}
		</Card>
	)
}

export default RemittedSalesTaxSection

